"use client";

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export function BackgroundManager() {
  const pathname = usePathname();

  useEffect(() => {
    // Only the home page (marketing page) should have transparent background
    // All other pages should have the blue background
    if (pathname === '/') {
      document.body.classList.remove('needs-background');
    } else {
      document.body.classList.add('needs-background');
    }

    // Cleanup function to remove class on unmount
    return () => {
      document.body.classList.remove('needs-background');
    };
  }, [pathname]);

  return null; // This component doesn't render anything
}